import React from 'react';
import PropTypes from 'prop-types';
import {
  StudentResultCellWrapper,
  Title,
  Content,
  IconWrapper
} from './student-result-cell.styled';
import SvgIcon from '../../../../svg-icon/svg-icon';

const StudentResultCell = ({ title, value, icon }) => {
  return (
    <StudentResultCellWrapper data-testid="student-result-cell">
      <Title>
        <IconWrapper>
          <SvgIcon icon={icon} />
        </IconWrapper>
        {title}
      </Title>
      <Content>{value}</Content>
    </StudentResultCellWrapper>
  );
};

StudentResultCell.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  icon: PropTypes.string
};

StudentResultCell.defaultProps = {
  container: false,
  icon: ''
};

export default StudentResultCell;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/student-result-cell/student-result-cell.js